<template>
  <div class="details-gallery">
    <div
      class="details-gallery__items owl-carousel"
      :class="{ 'details-gallery__items--overlay': isGallery }"
      ref="carousel"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        class="details-gallery__item-wrap"
        :class="{ 'details-gallery__item-wrap--auto': isAutoHeight }"
      >
        <details-video v-if="item.type === 'video'" :src="item.src"/>
        <div
          v-if="item.type === 'photo'"
          :style="{ backgroundImage: `url(${ item.src })` }"
          class="details-gallery__item details-gallery__item--photo"
        />
      </div>
    </div>
    <transition name="quick-fade">
      <div
        v-if="showPrevious"
        key="1"
        class="details-gallery__nav details-gallery__nav--previous"
      >
        <button-component
          color="light"
          type="half-left"
          @click="previous"
        >Poprzednie</button-component>
      </div>
    </transition>
    <transition name="quick-fade">
      <div
        v-if="showNext"
        key="2"
        class="details-gallery__nav details-gallery__nav--next"
      >
        <button-component
          color="light"
          type="half-right"
          @click="next"
        >Następne</button-component>
      </div>
    </transition>
  </div>
</template>

<script>
import ButtonComponent from '@/components/Button'
import DetailsVideo from '@/containers/Details/DetailsVideo'

export default {
  components: {
    ButtonComponent,
    DetailsVideo
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      active: 0
    }
  },
  computed: {
    showNext () {
      return this.active < this.items.length - 1
    },
    showPrevious () {
      return this.active && this.items.length
    },
    isGallery () {
      return this.items.length > 1
    },
    isAutoHeight () {
      return this.items.some(item => item.type === 'video')
    }
  },
  watch: {
    items () {
      this.destroyCarousel()
      this.initializeCarousel()
    }
  },
  mounted () {
    this.initializeCarousel()
  },
  methods: {
    initializeCarousel () {
      if (this.items.length) {
        this.$nextTick(() => {
          const { carousel } = this.$refs

          /* eslint-disable */
          this.owl = $(carousel).owlCarousel({
            dots: false,
            pullDrag: false,
            items: 1,
            onChanged: evt => this.active = evt.item.index
          })
          /* eslint-enable */
        })
      }
    },
    destroyCarousel () {
      const { carousel } = this.$refs
      this.active = 0
      /* eslint-disable */
      $(carousel).owlCarousel('destroy')
      /* eslint-enable */
    },
    next () {
      this.owl.trigger('next.owl.carousel')
    },
    previous () {
      this.owl.trigger('prev.owl.carousel')
    }
  }
}
</script>

<style lang="scss" scoped>
  .details-gallery {
    position: relative;
    padding-bottom: 25px;

    &__item {
      @include cover-background;
      height: 100%;
    }

    &__items--overlay &__item--photo {
      position: relative;

      &::after {
        content: '';
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0) 65%,
          rgba(33, 33, 33, 1) 100%
        );

        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        pointer-events: none;
      }
    }

    &__item-wrap {
      height: 40vh;

      @include media-up(md) {
        height: 280px;
      }

      @include media-up(lg) {
        height: 320px;
      }

      &--auto {
        height: auto;
      }
    }

    &__item-wrap--auto &__item--photo {
      padding-bottom: 56.25%;
      height: 0;
    }

    &__items {
      position: relative;
    }

    &__nav {
      position: absolute;
      bottom: 7vw;

      @include media-up(sm) {
        bottom: 8vw;
      }

      @include media-up(md) {
        bottom: 12%;
      }

      @include media-up(xl) {
        bottom: 8%;
      }

      &--next {
        right: -10px;
      }

      &--previous {
        left: -10px;
      }

      transform: translateY(-100%);
      z-index: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Details/DetailsGallery.vue